import { render, staticRenderFns } from "./dialog-receiver-update.vue?vue&type=template&id=ead120a6&"
import script from "./dialog-receiver-update.vue?vue&type=script&lang=js&"
export * from "./dialog-receiver-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports